/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_Q2Inputs */

const en_to_csv_faq_q2 = /** @type {(inputs: To_Csv_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are nested objects handled?`)
};

const ko_to_csv_faq_q2 = /** @type {(inputs: To_Csv_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩된 객체는 어떻게 처리되나요?`)
};

const ja_to_csv_faq_q2 = /** @type {(inputs: To_Csv_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストされたオブジェクトはどう処理されますか？`)
};

/**
* | output |
* | --- |
* | "How are nested objects handled?" |
*
* @param {To_Csv_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_q2 = /** @type {((inputs?: To_Csv_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_q2(inputs)
	if (locale === "ko") return ko_to_csv_faq_q2(inputs)
	return ja_to_csv_faq_q2(inputs)
});